import { useMemo } from "react"
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam"

const getLmsTitleImageRaw = (team?: ComputedTeam): string =>
    (team as any)?.additionalInfo?.lmstitleimage
    ?? (team as any)?.additionalContent?.additionalInfo?.lmstitleimage
    ?? "[]";

export const useGetLMSImage = (team?: ComputedTeam): File[] => {
    return useMemo(() => {
        const raw = getLmsTitleImageRaw(team);
        try {
            return JSON.parse(raw) ?? [];
        } catch {
            return [];
        }
    }, [team]);
}import { useMemo } from "react"
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam"

const getLmsTitleImageRaw = (team?: ComputedTeam): string =>
    (team as any)?.additionalInfo?.lmstitleimage
    ?? (team as any)?.additionalContent?.additionalInfo?.lmstitleimage
    ?? "[]";

export const useGetLMSImage = (team?: ComputedTeam): File[] => {
    return useMemo(() => {
        const raw = getLmsTitleImageRaw(team);
        try {
            return JSON.parse(raw) ?? [];
        } catch {
            return [];
        }
    }, [team]);
}